class AppMap extends Component {
	constructor(el) {
		super(el);
		this.map = null;
		this.constructObserver().observe(this.$el);
		this.styles = [
			{
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#f5f5f5"
					}
				]
			},
			{
				"elementType": "labels.icon",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#616161"
					}
				]
			},
			{
				"elementType": "labels.text.stroke",
				"stylers": [
					{
						"color": "#f5f5f5"
					}
				]
			},
			{
				"featureType": "administrative.country",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#b0b0b0"
					},
					{
						"weight": 3
					}
				]
			},
			{
				"featureType": "administrative.land_parcel",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#bdbdbd"
					}
				]
			},
			{
				"featureType": "poi",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#eeeeee"
					}
				]
			},
			{
				"featureType": "poi",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#757575"
					}
				]
			},
			{
				"featureType": "poi.park",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#e5e5e5"
					}
				]
			},
			{
				"featureType": "poi.park",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#9e9e9e"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#ffffff"
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#757575"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#dadada"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#616161"
					}
				]
			},
			{
				"featureType": "road.local",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#9e9e9e"
					}
				]
			},
			{
				"featureType": "transit.line",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#e5e5e5"
					}
				]
			},
			{
				"featureType": "transit.station",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#eeeeee"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#c9c9c9"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#9e9e9e"
					}
				]
			}
		];

		this.markerSvg = '<svg width="58" height="81" viewBox="0 0 59 81" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.4 43.8H0v32L2.2 81l2.2-5.1V43.8Z" fill="#4B4B4B"/><path fill-rule="evenodd" clip-rule="evenodd" d="M43.8 0v43.8h14.6l-14.6-22L58.4 0H43.8ZM0 0h43.8v43.8H0V0Z" fill="#246DBF"/><path d="M7 18v8h10.7l5.2-2.6 3.8 2.6H40l-9-6.3 3.3-1.7H19.7l-2.4 1.6V18H7Z" fill="#fff"/></svg>';
	}

	initMap() {
		const points = JSON.parse(this.$el.dataset.points);
		const mapCenter = JSON.parse(this.$el.dataset.center);

		this.map = new google.maps.Map(this.$el, {
			zoom: +this.$el.dataset.zoom,
			center: {lat: mapCenter[0], lng: mapCenter[1]},
		});

		this.map.setOptions({styles: this.styles});

		points.forEach(point => {
			const marker = new google.maps.Marker({
				position: point,
				animation: google.maps.Animation.DROP,
				map: this.map,
				icon: {
					url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(this.markerSvg),
					//path: 'M9.54,51.873C1.494,40.208,0,39.011,0,34.724c0-5.872,4.761-10.634,10.632-10.634c5.873,0,10.633,4.762,10.633,10.634c0,4.287-1.494,5.483-9.54,17.148C11.197,52.636,10.068,52.636,9.54,51.873L9.54,51.873zM10.632,39.155c2.447,0,4.431-1.983,4.431-4.43c0-2.447-1.983-4.432-4.431-4.432c-2.447,0-4.43,1.984-4.43,4.432C6.202,37.172,8.186,39.155,10.632,39.155z',
					anchor: new google.maps.Point(10.6325, 28.355),
					fillColor: point.markerColor ? point.markerColor : Templating.baseColor,
					fillOpacity: 1,
					strokeWeight: 0,
					scale: 1
				}
			});

			if(point.showInfo) {
				const infowindow = new google.maps.InfoWindow();
				const content = this.renderInfoWindow(point.title, point.description, point.url);

				google.maps.event.addListener(marker, 'click', ((marker, content, infowindow) => {
					return () => {
						infowindow.setContent(content);
						infowindow.open(this.map, marker);
					};
				})(marker, content, infowindow));
			}
		});
	}

	renderInfoWindow(title, description, url) {
		return `<div class="MapInfoWindow">
			<div class="MapInfoWindow-title">
				${url ? ('<a href="'+url+'">'+title+'</a>') : title}
			</div>
			<div class="MapInfoWindow-description">${description}</div>
		</div>`;
	}

	loadMapResources() {
		if (document.querySelector('#google-map-api')) {
			this.initMap();
		} else {
			const mapsJS = document.createElement('script');
			mapsJS.id = 'google-map-api';
			mapsJS.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.$el.dataset.apiKey;
			document.querySelector('head').appendChild(mapsJS);
			mapsJS.onload = () => {
				this.initMap();
			};
		}
	}

	constructObserver() {
		return new IntersectionObserver(
			(entries, self) => {
				const isIntersecting = typeof entries[0].isIntersecting === 'boolean' ? entries[0].isIntersecting : entries[0].intersectionRatio > 0;
				if (isIntersecting) {
					this.loadMapResources();
					self.unobserve(this.$el);
				}
			},
			{
				rootMargin: '100px',
				threshold: 0
			}
		);
	}


}